import React from "react";
import { UserProvider } from "./Widgets/UserContext";
import Navigation from "./Widgets/Navigation";
import { BlurProvider } from "./Widgets/BlurContext";
import { TutorialProvider } from "./Screens/Helpers/Tutorials";
import VersionBadge from "./Widgets/VersionBadge";

// Suppress known React Native Web warnings that are cosmetic and do not affect functionality.
// These come from library code (react-navigation, etc.) and RNW internals.
if (typeof console !== 'undefined') {
  const suppressPatterns = [
    'Unexpected text node',
    'props.pointerEvents is deprecated',
    'TouchableOpacity is deprecated',
    'focusable is deprecated',
    'style.resizeMode is deprecated',
    '"transform" style array value is deprecated',
    '"shadow*" style props are deprecated',
    '"textShadow*" style props are deprecated',
    '"textAlignVertical" style is deprecated',
    'selectable prop is deprecated',
    'View map container not available',
    'Download the React DevTools',
  ];
  const originalError = console.error;
  const originalWarn = console.warn;
  const shouldSuppress = (args) => {
    const msg = typeof args[0] === 'string' ? args[0] : '';
    return suppressPatterns.some(p => msg.includes(p));
  };
  console.error = (...args) => { if (!shouldSuppress(args)) originalError.apply(console, args); };
  console.warn = (...args) => { if (!shouldSuppress(args)) originalWarn.apply(console, args); };
}

// Inject global CSS to fix iOS Safari double-tap delay on interactive elements
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    [role="button"], button, a, input, textarea, select,
    [data-focusable="true"], [tabindex] {
      touch-action: manipulation;
    }
  `;
  document.head.appendChild(style);
}

const App = () => {
  return (
    
      <BlurProvider>
        <UserProvider>
          <TutorialProvider>
            <Navigation />
          </TutorialProvider>
          <VersionBadge />
        </UserProvider>
      </BlurProvider>
  );
};

export default App;